import React, { useState } from 'react'
import { useFormik } from 'formik';
import * as Yup from 'yup'
import TextField from '../TextField/TextField';
import { Auth } from 'aws-amplify';
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

const MySwal = withReactContent(Swal)

const initialValues = {
    currentPassword : '',
    newPassword : '',
    confirmNewPassword : ''
}

const enrollSchema = Yup.object().shape({
    currentPassword : Yup.string().required('Current Password is required'),
    newPassword : Yup.string().required('New Password is required'),
    confirmNewPassword : Yup.string().required('Confirm New Password is required').oneOf([Yup.ref('newPassword')], 'Your password do not match.')

})

const ResetPassword = () => {
    const [editMode, setEditMode] = useState<boolean>(false);
    const [passwordType, setPasswordType] = useState<any>('password')
    const [passwordShow, setPasswordShow] = useState<any>('password')
    
    const ClickEditMode = () => {
        setEditMode(true)
    }

    const removeEditMode = () => {
        setEditMode(false)
        formik.resetForm()
    }

    const handleOnChange = (e: any, name: string) => {
        formik.setFieldValue(name, e.target.value);
    }

    const showPassword = () => {
        passwordType === 'password' ? setPasswordType('text') : setPasswordType('password')
    }

    const showNewPassword = () => {
        passwordShow === 'password' ? setPasswordShow('text') : setPasswordShow('password')
    }
    

    const formik = useFormik({
        initialValues,
        validationSchema : enrollSchema,
        enableReinitialize: true,
        onSubmit: async (values) => {
            Auth.currentAuthenticatedUser()
            .then((user) => {                
                return Auth.changePassword(user, values.currentPassword, values.newPassword);
            })
            .then((data) => { 
                if(data === 'SUCCESS'){
                const options: any = {
                    customClass: {
                    popup: 'swal2-border-radius',
                    },
                    title: 'Password updated successfully',
                    icon: 'success',
                    confirmButtonColor: '#3E97FF',
                }
                MySwal.fire(options);
               }else{
                MySwal.fire({
                    icon: 'error',
                    title: 'Error in updating password',
                  })
               }
            }
            )
            .catch((err) =>  
                MySwal.fire({
                    icon: 'error',
                    title: err.message,
                }));
            removeEditMode()
        }
       
    })

  return (
    <>
        <div className='card mt-5'>
           <div className='card-body'>
                <div className='row border-bottom'>
                   <h2 className='mb-5'>Reset Password</h2>
                </div>

                <div className={`row mt-3 ${editMode ? 'd-none' : null}`}>
                    <div className='col-lg-6 mt-5'>
                        <label className='d-flex align-items-center mb-2'><span className='fs-6 fw-500'>Password</span></label>
                        <div className='text-muted'>**********</div>
                    </div>
                    <div className='col-lg-6 mt-5 text-end'>
                        <button type='button' className='btn btn-light' onClick={()=>ClickEditMode()}>Reset Password</button>
                    </div>
                </div>
            
                <form onSubmit={formik.handleSubmit}>
                    <div className={`row mt-3 ${editMode ? null : 'd-none'}`}>
                        <div className="col-lg-4 mb-5">
                           <TextField
                                fieldType = {'password'}
                                fieldTitle={'Current Password'}
                                filedTitleMandatory={true}
                                fieldName={'currentPassword'}
                                placeHolder={'Enter current password'}
                                maxLength={'30'}
                                handleOnChange={handleOnChange}
                                formik={formik}
                                fieldValue={formik.getFieldMeta('currentPassword').value}
                            />
                            {formik?.touched ? '' : (<span className='small text-muted mt-4'>Use 8 or more characters with a mix of letters, numbers & symbols</span>) }
                        </div>
                        <div className="col-lg-4 mb-5">
                           <TextField
                                fieldType = {passwordShow}   
                                fieldTitle={'New Password'}
                                filedTitleMandatory={true}
                                fieldName={'newPassword'}
                                placeHolder={'Enter new password'}
                                maxLength={'30'}
                                handleOnChange={handleOnChange}
                                formik={formik}
                            />
                             <div style={{position: 'absolute',right: '36%',top: '44%',}}>
                                {passwordShow === 'password' ? (
                                    <i
                                    className='bi bi-eye-slash'
                                    style={{fontSize: '20px'}}
                                    onClick={showNewPassword}
                                    ></i>
                                ) : (
                                    <i
                                    className='bi bi-eye'
                                    style={{fontSize: '20px'}}
                                    onClick={showNewPassword}
                                    ></i>
                                )}
                            </div>

                        </div>
                        <div className="col-lg-4 mb-9">
                            <TextField
                                fieldType = {passwordType}
                                fieldTitle={'Confirm New Password'}
                                filedTitleMandatory={true}
                                fieldName={'confirmNewPassword'}
                                placeHolder={'Enter confirm new password'}
                                maxLength={'30'}
                                handleOnChange={handleOnChange}
                                formik={formik}
                            />
                             <div style={{position: 'absolute',right: '4%',top: '44%',}}>
                                {passwordType === 'password' ? (
                                    <i
                                    className='bi bi-eye-slash'
                                    style={{fontSize: '20px'}}
                                    onClick={showPassword}
                                    ></i>
                                ) : (
                                    <i
                                    className='bi bi-eye'
                                    style={{fontSize: '20px'}}
                                    onClick={showPassword}
                                    ></i>
                                )}
                            </div>
                        </div>
                        <div className='border-top d-flex flex-stack pt-5'>
                            <div className='me-2'></div>
                            <div className='d-flex'>
                                <button type='reset' className='btn btn-light me-3' onClick={()=>removeEditMode()}>Cancel</button>
                                <button type='submit' className='btn btn-lg btn-primary'>Update Password</button>
                            </div>
                        </div>
                    </div>
                </form>

            </div>
        </div>
    </>
  )
}

export default ResetPassword
